import { api } from "@/shared/api/baseApi";
import type { OnboardUserBody, OnboardingResponse } from "@keystone/contracts/onboarding";

const onboardingApi = api.enhanceEndpoints({ addTagTypes: ["User"] }).injectEndpoints({
  endpoints: (build) => ({
    onboardUser: build.mutation<OnboardingResponse, OnboardUserBody>({
      query: (body) => ({ url: "/onboarding", method: "POST", body }),
      invalidatesTags: [{ type: "User", id: "LIST" }],
    }),
  }),
});

export const { useOnboardUserMutation } = onboardingApi;
export { onboardingApi };
